import styled from './QuienesSomos.module.css';





    const QuienesSomos = () => {


        return(

            <div className={styled.container}>
                <p className={styled.pr}>
                Comercializadora Autocolor Angel 21 C.A es una empresa líder en la industria de pintura automotriz, con una amplia experiencia y reconocimiento en el mercado. Nos especializamos en ofrecer soluciones personalizadas y de alta calidad para el repintado de vehículos, incluyendo motos. Nuestro equipo de profesionales capacitados y tecnología avanzada nos permite brindar resultados impecables y duraderos en cada proyecto. Nuestra misión es mantenernos a la vanguardia, proporcionando productos y servicios excepcionales para satisfacer las necesidades de nuestros clientes, tanto en automóviles como en motos, y consolidarnos como líderes en el mercado de la pintura automotriz.
                </p>
                <div className={styled.divided}>
                    <div className={styled.paragrapthOne}>
                        <p className={styled.paragrapthEdit}>
                        MISIÓN:
                        En Comercializadora Autocolor Angel 21 C.A, nuestra misión es brindar soluciones de pintura automotriz personalizadas y de alta calidad para realzar la belleza y proteger la durabilidad de los vehículos de nuestros clientes. Nos apasiona la excelencia y nos esforzamos por superar expectativas en cada proyecto.

                        </p>
                    </div>   
                    <div className={styled.paragrapthTwo}>
                        <p className={styled.paragrapthEdit} >
                        VISIÓN:

                        Ser líderes en pintura automotriz, ofreciendo soluciones innovadoras y de alta calidad que superen las expectativas de nuestros clientes.

                        </p>
                    </div>
                 </div> 

            </div>

        )


    }

    export default QuienesSomos;